// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-secondary-button {
  border-radius: 20px;
  background-color: var(--planeed-light-gray);
  color: var(--planeed-gray);
  min-width: 140px;
  height: 35px;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.map-secondary-button:hover {
  background-color: var(--planeed-gray);
  color: var(--planeed-dark-gray);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
